let current: HTMLAudioElement | null = null;

export function playAudio(src: string | null | undefined): Promise<boolean> {
  if (!src) return Promise.resolve(false);
  current?.pause();
  const audio = new Audio(src);
  current = audio;
  return audio
    .play()
    .then(() => true)
    .catch(() => false);
}
